import { useQuery } from "@tanstack/react-query";
import { API_BASE_URL } from "../../constants";

export const useTrainingsQuery = () => {
    const token = localStorage.getItem("token");

    return useQuery({
        queryKey: ["useTrainingsQuery", token],
        queryFn: async () => {
            const result = await fetch(`${API_BASE_URL}/courses`, {
                headers: {
                    authorization: `Bearer ${token}`,
                },
            }).then(res => res.json());
            return result.data;
        },
    });
}